import React, { useState } from "react";
import { useDispatch } from "react-redux";

import organizationActions from "store/organizations/actions";

import Toggle from "components/Input/Toggle";

import classes from "./style.module.scss";

const { updateOrganization } = organizationActions;

// The organization's codes are merged into every member's library, so they are offered in every
// model that member opens. Admins decide whether that is what they want: turned off, the codes are
// only offered in the models sitting in the organization's shared folder.
const CodeLibVisibility = ({ orgId, orgMeta: { allowCodeLibOutsideOrg = true } = {}, setAlert }) => {
    const dispatch = useDispatch();

    const [saving, setSaving] = useState(false);

    return (
        <section className={classes.settingsCard}>
            <div>
                <h3>Organization Code Library Visibility</h3>
                <p>
                    Let members use this organization's code library in any model they create or open. When turned off,
                    the organization's codes are only accessible in models within the shared organization folder.
                </p>
            </div>
            <Toggle
                active={allowCodeLibOutsideOrg}
                disabled={saving}
                onChange={async () => {
                    setSaving(true);

                    await dispatch(
                        updateOrganization(orgId, { orgMeta: { allowCodeLibOutsideOrg: !allowCodeLibOutsideOrg } })
                    );

                    setSaving(false);

                    setAlert({
                        open: true,
                        message: allowCodeLibOutsideOrg
                            ? "The organization's codes are now only available in shared folder models."
                            : "The organization's codes are now available in every model.",
                        anchorOrigin: { vertical: "top", horizontal: "center" },
                        direction: "down",
                    });
                }}
            />
        </section>
    );
};

export default CodeLibVisibility;
